<template>
  <div class="d-flex align-items-center min-vh-100">
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>
                <CRow>
                  <CCol col="6">
                    <CInput
                      placeholder="User ID"
                      autocomplete="userName"
                      name="User_Id"
                      type="number"
                    >
                      <!-- <template #prepend-content><CIcon name="cil-user"/></template> -->
                    </CInput>
                  </CCol>

                  <!-- <CCol col="6">	
				<CInput
                  placeholder="Role ID"
                  autocomplete="Role_Id" name="Role_Id" value="11" hidden
                >
                </CInput>
                  </CCol> -->

                  <CCol col="6">
                    <CInput placeholder="First Name" name="FirstName">
                      <!-- <template #prepend-content><CIcon name="cil-user"/></template>                                 -->
                    </CInput>
                  </CCol>

                  <CCol col="6">
                    <CInput placeholder="Last Name" name="LastName" />
                  </CCol>

                  <CCol col="6">
                    <CInput
                      placeholder="Username"
                      autocomplete="userName"
                      name="UserName"
                    >
                      <!-- <template #prepend-content><CIcon name="cil-user"/></template> -->
                    </CInput>
                  </CCol>

                  <CCol col="6">
                    <CInput
                      placeholder="Email"
                      autocomplete="off"
                      name="UserEmail"
                    />
                    <!-- prepend="@" -->
                  </CCol>

                  <CCol col="6">
                    <CInput
                      placeholder="Password"
                      type="password"
                      name="Password"
                      autocomplete="off"
                    >
                      <!-- <template #prepend-content><CIcon name="cil-lock-locked"/></template> -->
                    </CInput>
                  </CCol>

                  <CCol col="6">
                    <CInput
                      placeholder="Repeat password"
                      type="password"
                      name="Re-Password"
                      autocomplete="off"
                      class="mb-4"
                    >
                      <!-- <template #prepend-content><CIcon name="cil-lock-locked"/></template> -->
                    </CInput>
                  </CCol>

                  <CCol col="6">
                    <CInput placeholder="Mobile No" name="MobileNo">
                      <!-- <template #prepend-content><CIcon name="cil-phone"/></template> -->
                    </CInput>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="6">
                    <CButton
                      color="btn btn-outline-light btn-block active"
                      block
                      @click="login()"
                      >Login</CButton
                    >
                  </CCol>

                  <CCol col="6">
                    <CButton color="success" block @click="viewMenuDash()"
                      >Register</CButton
                    >
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="12" class="text-left">
                    <p style="color: red" id="reponse_error"></p>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
            <!-- <CCardFooter class="p-4">
              <CRow>
                <CCol col="6">
                  <CButton block color="facebook">
                    Facebook
                  </CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="twitter">
                    Twitter
                  </CButton>
                </CCol>
              </CRow>
            </CCardFooter> -->
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      menuName: this.$route.MenuName,
      title: "Register",
      options: ["Deactive"],
      IPAddress: "172.16.2.30",
      Latitude: "21.2354158452",
      Longitude: "72.89745852",
      isLoading: false,
    };
  },
  mounted() {
    //console.log('success');
    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        this.IPAddress = ip;
      });

    const success = (position) => {
      this.Latitude = position.coords.latitude;
      this.Longitude = position.coords.longitude;
      //console.log(this.latitude+' '+this.longitude);
    };

    const error = (err) => {
      console.log(error);
    };

    // This will open permission popup
    navigator.geolocation.getCurrentPosition(success, error);
  },
  methods: {
    login() {
      this.$router.push({ path: "Login" });
    },
    viewMenuDash() {
      var User_Id = $("input[name=User_Id]").val();
      var Role_Id = "3";
      // var Role_Id=$('input[name=Role_Id]').val();
      var FirstName = $("input[name=FirstName]").val();
      var LastName = $("input[name=LastName]").val();
      var UserName = $("input[name=UserName]").val();
      var UserEmail = $("input[name=UserEmail]").val();
      var MobileNo = $("input[name=MobileNo]").val();
      var Password = $("input[name=Password]").val();
      var RePassword = $("input[name=Re-Password]").val();
      //var Status="In-Active";
      var Status = "Active";
      var ProfileImage = "";
      var IPAddress = this.IPAddress;
      var Latitude = this.Latitude;
      var Longitude = this.Longitude;

      if (Password == RePassword) {
	    this.isLoading = true;
        var requestInfo = {
          User_Id: User_Id,
          Role_Id: Role_Id,
          FirstName: FirstName,
          LastName: LastName,
          UserName: UserName,
          UserEmail: UserEmail,
          MobileNo: MobileNo,
          Password: Password,
          Status: Status,
          ProfileImage: ProfileImage,
          IPAddress: IPAddress,
          Latitude: Latitude,
          Longitude: Longitude,
        };
        //console.log(requestInfo);
        //return false;
        var axios = require("axios");
        var data = JSON.stringify(requestInfo);

        var config = {
          method: "post",
          url: apiURL + "Authentication/UserRegistration",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        axios(config)
          .then((response) => {
            this.isLoading = false;
            //console.log(JSON.stringify(response.data));
            if (response.data.status_code == 200) {
              $("#reponse_error").html(response.data.message);
              //this.$router.push({name:'Dashboard'})
            } else {
              $("#reponse_error").html(response.data.message);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
            console.log(error);
          });
      } else {
        $("#reponse_error").html("Password or Re-Password Did't Match..!");
        return false;
      }
      //this.$router.push({name:'Login'})
    },
  },
};
</script>
